<template>
    <div class="order-item">
        <ul class="tab-head">
            <li>订单详情</li>
            <li>成交金额</li>
            <li>数量</li>
            <li>支付总金额</li>
            <li>订单状态</li>
            <li>操作</li>
        </ul>
        <ul class="order-list">
            <li v-for="(item,index) in orderList" :key="index">
                <ul class="list-head">
                    <li><i class="el-icon-document ico-order"></i><span class="tab-lab">订单号：</span>{{item.orderNum}}</li>
                    <li><span class="tab-lab">创建时间：</span>{{item.createTime}}</li>
                    <li><!--<button type="button" class="el-icon-delete btn-del"></button>--></li>
                </ul>
                <ul class="list-body">
                    <li>
                        <el-image class="order-img" :src="$common.imgPath(item.goods.goodsLog)" :alt="item.goods.goodsName" lazy></el-image>
                        <span class="order-title">{{item.goods.goodsName}}</span>
                    </li>
                    <li class="txt-14">¥{{item.orderPrice}}</li>
                    <li class="txt-16">{{item.goodsNum}}</li>
                    <li class="line">
                        <p class="total-money font-500" v-text="item.status==0?'¥'+(item.orderPrice+item.goods.distributionFee):item.realPrice">¥</p>
                        <p class="txt-13 c-999">{{item.goods.distributionFee==-1?'邮费到付':item.goods.distributionFee==0?'包邮':'含运费:¥'+item.goods.distributionFee}}</p>
                    </li>
                    <li class="line">
                        <p v-if="item.isOnline==1">线下支付</p>
                        <p v-if="item.isOnline!=1" v-text="orderPayText(item.createTime,item.status,item.goods.goodsType,item.isReturn)"></p>
                        <p @click="$router.push({'path':`/myCenter/order/detail/${item.id}/${role}`})" style="cursor:pointer;">查看详情</p>
                    </li>
                    <li class="line">
                        <div v-if="role==='user'">
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==0&&item.isOnline!=1" @click="$router.push({'path':'/goods/order/pay/'+item.id})">去支付</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==0&&item.goods.goodsType==1&&item.isOnline!=1" @click="cancelOrder(item.id,item.shop.shopId)">取消订单</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==1" @click="allPushContentOpt(item.id)">催一催</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==2" @click="orderCheckOver(item.id)">确认收货</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==3" @click="$router.push({'path':'/goods/order/pinJia/'+item.id})">去评价</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="(item.status==2||item.status==3)&&item.isReturn===0" @click="$router.push({'path':'/goods/order/applyAfterSale/'+item.id})">申请售后</button>
                        </div>
                        <div v-if="role==='shop'">
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.isOnline==1" @click="applyStatus(3,item)">拒绝申请</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.isOnline==1" @click="applyStatus(2,item)">同意申请</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==0&&item.goods.goodsType==1&&item.isOnline!=1" @click="delOrder(item.id,item.shop.shopId)">删除</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==6&&item.isOnline!=1" @click="delOrder(item.id,item.shop.shopId)">删除</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==1" @click="sendOrder(item.id,item.goods.distributionFee)">确认发货</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==5&&item.isReturn==0" @click="setReturnOrderNo(item.id)">取消退款</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==5&&item.isReturn==0" @click="setReturnOrder(item.id)">确认退款</button>
                            <button type="button" class="btn-base btn-mini btn-item" v-if="item.status==6&&item.isBlack!==1&&item.goods.goodsType!==1" @click="pullBlackUser(item.id)">拉黑</button>
                        </div>
<!--
                        <button type="button" class="btn-base btn-mini btn-item" v-if="role==='shop'&& orderPayText(item.createTime,item.status,item.goods.goodsType,item.isReturn)==='已失效'" @click="cancelPullBlackUser(item.id)">取消拉黑</button>
-->
                    </li>
                </ul>
            </li>

        </ul>
    </div>

</template>
<script>
    import {pullBlack,cancelPullBlack} from '../../api/shop'
    import {allPushContent,userCheckOver,sendOrder,returnOrder,returnOrderNo,delForUser,statusOnline} from '../../api/order'
    export default {
        props:{
            role:{
                type:String,
                default:'user'
            },
            orderList:[Array],
            nowTime:{
                type:String,
                default:new Date()
            }
        },
        computed:{
        },
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('user'))||null,
                currTimeStamp:Date.parse(this.nowTime),
                statusText:''
            }
        },
        methods:{
            applyStatus(status,orderInfo){
                //isOnline 3拒绝申请 2 同意申请
                let str = status==2?'是否线下收到支付款项，同意线下订单支付申请？':'是否拒绝线下订单支付申请？';
                this.$confirm('', str, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    statusOnline({
                        orderId:orderInfo.id,
                        status
                    }).then(res=>{
                        this.$emit('change')
                    })
                }).catch(() => {});

            },
            orderPayText(createTime,status,goodsType,isReturn){
                let statusStr;
                let createTimeStamp=parseInt(Date.parse(createTime));
                let nowTimeStamp = parseInt(this.currTimeStamp);
                let failureTime = createTimeStamp+(24*60*60*1000);//超过24小时后订单失效
                switch (status){
                    case 0:
                        statusStr=this.role==='user'?'待付款':'等待买家付款';
                        break;
                    case 1:
                        statusStr ='待发货';
                        break;
                    case 2:
                        statusStr =this.role==='user'?'待收货':'等待买家收货';
                        break;
                    case 3:
                        statusStr ='待评价';
                        break;
                    case 4:
                        statusStr ='已完成';
                        break;
                    case 5:
                        statusStr = isReturn==0?(this.role==='user'?'售后审核中':'售后'):isReturn==1?'已退款':isReturn==2?'已拒绝':'';
                        break;
                    case 6:
                        statusStr = '已失效';
                        break;
                    default:
                        statusStr ='';
                        break;
                }
                return statusStr;
            },
            sendOrder(orderId,distributionFee){
                if(distributionFee==-1){
                    sendOrder({
                        orderId
                    }).then(res=>{
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                        this.$emit('change')
                    })
                }else{
                    this.$prompt('填写运单号', '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:(val)=>{
                            if(!val){
                                return false;
                            }
                        },
                        inputErrorMessage: '运单号不能为空'
                    }).then(({ value }) => {
                        sendOrder({
                            takeNum:value,
                            orderId
                        }).then(res=>{
                            this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            this.$emit('change')
                        })
                    }).catch(() => {});
                }
            },
            setReturnOrder(orderId){
                this.$prompt('退款', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder:'请输入退款金额',
                    inputValidator:(val)=>{
                        if(!val){
                            return false;
                        }
                    },
                    inputErrorMessage: '退款金额不能为空'
                }).then(({ value }) => {
                    returnOrder({
                        shopId:this.userInfo.shopId,
                        money:value,
                        orderId
                    }).then(res=>{
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                        this.$emit('change')
                    })
                }).catch(() => {});
            },
            setReturnOrderNo(orderId){
                this.$confirm('确认拒绝退款？')
                    .then(()=> {
                        returnOrderNo({
                            orderId
                        }).then((res)=>{
                            this.$message({
                                message:res.msg,
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});
            },
            pullBlackUser(orderId){
                this.$confirm('将该用户拉入黑名单！根据系统设置，买家被任意商家拉黑三次之后，将失去全平台购买资格，解除权限由拉黑商家才能解除。')
                    .then(()=> {
                        pullBlack({
                            shopId:this.userInfo.shopId,
                            orderId
                        }).then((res)=>{
                            this.$message({
                                message:res.msg,
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});
            },
            cancelPullBlackUser(orderId){
                this.$confirm('确认取消拉黑用户？')
                    .then(()=> {
                        cancelPullBlack({
                            pullBlackId:this.userInfo.shopId,
                            orderId
                        }).then((res)=>{
                            this.$message({
                                message:res.msg,
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});
            },
            cancelOrder(orderId,shopId){
                this.$confirm('确认取消订单？')
                    .then(()=> {
                        delForUser({
                            shopId,
                            orderId
                        }).then((res)=>{
                            this.$message({
                                message:res.msg,
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});
            },
            delOrder(orderId,shopId){
                this.$confirm('确认删除订单？')
                    .then(()=> {
                        delForUser({
                            shopId,
                            orderId
                        }).then((res)=>{
                            this.$message({
                                message:res.msg,
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});
            },
            allPushContentOpt(orderId){
                allPushContent({
                    userId:this.userInfo.userId,
                    orderId
                }).then(res=>{
                    this.$message({
                        message:res.msg,
                        type:'success'
                    });
                    this.$emit('change')
                }).catch(err=>err);
            },
            orderCheckOver(orderId){
                this.$confirm('确认收货？')
                    .then(()=> {
                        userCheckOver({
                            userId:this.userInfo.userId,
                            orderId
                        }).then(()=>{
                            this.$message({
                                message:'确认收获成功',
                                type:'success'
                            });
                            this.$emit('change')
                        }).catch(err=>err);
                    }).catch(() => {});

            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/common';
    .order-item{
        .tab-head{
            display: table;
            width:100%;
            height:40px;
            background-color:#F5F5F5;
            font-size:14px;
            color:#333;
            li{
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                width:124px;
                &:first-child{
                    width:400px;
                }

            }
        }
        .order-list{
            padding:26px 0;
            &>li{
                &+li{
                    margin-top:26px;
                }
                border:1px solid #E0E0E0;
                .list-head{
                    display: table;
                    width:100%;
                    height:40px;
                    font-size:14px;
                    line-height:40px;
                    background-color:#F5F5F5;
                    &>li{
                        display: table-cell;
                        vertical-align: middle;
                        .tab-lab{color:#999;}
                        &:first-child{padding-left:20px;width:280px;}
                        &:last-child{text-align: center}
                        .btn-del,.ico-order{font-size:17px;color:#999;}
                        .ico-order{padding-right:5px;}
                    }
                }
                .list-body{
                    display: table;
                    li{
                        display: table-cell;
                        vertical-align: middle;
                        width:124px;
                        text-align: center;
                        padding:20px 0;
                        &.line{
                            border-left:1px solid #E0E0E0;
                            .btn-item+.btn-item{
                                margin-top:10px;
                            }
                        }
                        &:first-child{
                            width:400px;
                            text-align: left;
                            padding-left:20px;
                        }
                    }
                    .order-img{
                        display: inline-block;
                        width:100px;
                        height:100px;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                        background-color:$main-color;
                    }
                    .order-title{
                        display: inline-block;
                        font-size:16px;
                        padding-left:10px;
                        width:208px;
                        vertical-align: top;
                        padding-top:8px;
                    }
                }
            }

        }
    }
</style>